import { sellerTable } from "../../../Component/style/sellerTable";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import api from "../../../Component/axios_Interceptor/api";
import url from "../../../Component/server";
import { LineGraph } from "../../../Component/UI/Chart";
import Layout_Admin from "../../../Component/UI/Layout_Admin";
import AdminPageHeader, { AdminActionButton } from "../../../Component/UI/AdminPageHeader";
import ExcessOrderGlobalModal from "./Modal/ExcessOrderGlobalModal";
import { dailyRows, DashboardData, statusCounts } from "./dashboardData";
import DashboardOperations from "./DashboardOperations";

const EXCESS_POPUP_SHOWN_KEY = "excess_order_popup_shown";
const number = (value: number) => value.toLocaleString("ko-KR");
const statuses = ["결제대기", "결제완료", "발주완료", "배송준비", "배송중", "배송완료", "주문취소", "환불처리", "사고처리"];

const Dashboard = styled.div`
  max-width: 1600px; margin: 0 auto; color: var(--admin-theme-text, #292633);
  * { box-sizing: border-box; }
  h1 { font-size: 25px; margin: 0 0 6px; letter-spacing: -0.5px; }
  h2 { font-size: 18px; margin: 0 0 6px; }
  p { margin: 0; color: var(--admin-theme-muted, #777381); font-size: 13px; line-height: 1.6; }
  button:not(.admin-header-action) { font: inherit; cursor: pointer; border: 1px solid var(--admin-theme-border, #dfdce5); background: var(--admin-theme-surface, white); border-radius: 7px; padding: 9px 13px; color: var(--admin-theme-text, #494451); }
  button:not(.admin-header-action):hover { border-color: var(--admin-theme-border, #b9add8); color: var(--admin-theme-link, #5138a2); }
  button:not(.admin-header-action):focus-visible { outline: 3px solid var(--admin-theme-focus, #a994e8); outline-offset: 3px; }
  button:not(.admin-header-action):disabled { cursor: wait; opacity: .6; }
  .header, .section-head { display: flex; align-items: center; justify-content: space-between; gap: 16px; flex-wrap: wrap; }
  .header { margin-bottom: 22px; }
  .updated { text-align: right; }
  .updated p { margin-top: 6px; }
  .metrics { display: grid; grid-template-columns: 1.25fr repeat(3, 1fr); margin-bottom: 20px; background: var(--admin-theme-surface, #fff); border: 1px solid var(--admin-theme-border, #e6e3eb); border-radius: 11px; }
  .card { min-width: 0; padding: 22px 24px; border-right: 1px solid var(--admin-theme-border, #ece9f0); }
  .card:last-child { border-right: 0; }
  .card .label { font-size: 13px; color: var(--admin-theme-muted, #6c6875); }
  .card strong { display: block; font-size: clamp(23px, 2vw, 31px); margin: 10px 0 5px; letter-spacing: -1px; overflow-wrap: anywhere; font-variant-numeric: tabular-nums; }
  .card strong small { font-size: 14px; font-weight: 500; margin-left: 4px; letter-spacing: 0; }
  .panel { background: var(--admin-theme-surface, white); border: 1px solid var(--admin-theme-border, #e6e3eb); border-radius: 11px; padding: 24px; min-width: 0; }
  .columns { display: grid; grid-template-columns: minmax(0, 1.7fr) minmax(280px, 1fr); gap: 20px; margin-bottom: 20px; }
  .tabs { display: flex; flex-wrap: wrap; gap: 6px; }
  button[aria-pressed="true"] { color: #fff; background: #51456e; border-color: #51456e; }
  .chart { height: 280px; margin-top: 20px; }
  .chart-controls { margin-top: 20px; }
  .task { display: flex; justify-content: space-between; align-items: center; gap: 8px; width: 100%; padding: 17px 0; text-align: left; border: 0; border-bottom: 1px solid var(--admin-theme-border, #eeebf1); border-radius: 0; }
  .task:hover { border-color: var(--admin-theme-border, #d8d0e5); background: var(--admin-theme-raised, #faf9fc); }
  .task strong { color: var(--admin-theme-text, #292633); white-space: nowrap; font-size: 15px; font-variant-numeric: tabular-nums; }
  .task small { display: block; font-size: 12px; color: var(--admin-theme-muted, #777381); margin-top: 4px; }
  .status-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); column-gap: 20px; margin-top: 15px; }
  .status { display: flex; align-items: baseline; justify-content: space-between; gap: 8px; min-width: 0; padding: 14px 0; border-bottom: 1px solid var(--admin-theme-border, #eeebf1); }
  .status span { font-size: 13px; color: var(--admin-theme-muted, #686471); }
  .status strong { font-size: 17px; font-weight: 650; font-variant-numeric: tabular-nums; white-space: nowrap; }
  .table-wrap { overflow: auto; max-height: 420px; margin-top: 20px; }
  table { width: 100%; border-collapse: collapse; font-size: 13px; white-space: nowrap; }
  table { ${sellerTable} }
  th, td { text-align: right; }
  th { position: sticky; top: 0; }
  th:first-child, td:first-child { text-align: left; }
  .notice { padding: 18px; border-radius: 8px; background: var(--admin-theme-danger-soft, #fff0f4); color: var(--admin-theme-danger, #a6002b); margin-bottom: 20px; }
  .empty { text-align: center; padding: 70px 20px; }
  .footnote { margin-top: 16px; }
  @media (max-width: 1100px) { .metrics { grid-template-columns: repeat(2, minmax(0, 1fr)); } .card:nth-child(2) { border-right: 0; } .card:nth-child(-n+2) { border-bottom: 1px solid var(--admin-theme-border, #ece9f0); } .columns { grid-template-columns: 1fr; } }
  @media (max-width: 540px) { .card, .panel { padding: 16px; } .metrics { grid-template-columns: 1fr; } .card, .card:nth-child(2) { border-right: 0; border-bottom: 1px solid var(--admin-theme-border, #ece9f0); } .card:last-child { border-bottom: 0; } .status-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); column-gap: 12px; } .updated { text-align: left; } }
`;

const Dashborad = () => {
  const navigate = useNavigate();
  const [operationsRefresh, setOperationsRefresh] = useState(0);
  const [data, setData] = useState<DashboardData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [updated, setUpdated] = useState<Date | null>(null);
  const [period, setPeriod] = useState("month");
  const [metric, setMetric] = useState<"amount" | "orders" | "buyers">("amount");
  const [excessModalVisible, setExcessModalVisible] = useState(false);
  const [excessInfo, setExcessInfo] = useState<{ live_start?: string; live_finish?: string; live_title?: string }>();
  const [excessCount, setExcessCount] = useState<number | null>(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(false);
    await Promise.all([
      api.get(url.Communication_url.store_dashboard).then(res => {
        if (!["paymentCount", "payersCount", "totalPayment", "orderStatus"].every(key => Array.isArray(res.data?.[key]))) throw new Error("Invalid dashboard response");
        setData(res.data);
        setUpdated(new Date());
      }).catch(() => setError(true)),
      api.get(url.Communication_url.oversell_notification).then(res => {
        if (!Array.isArray(res.data)) throw new Error("Invalid notification response");
        setExcessCount(res.data.length);
        setExcessInfo(res.data[0]);
        if (res.data.length && !sessionStorage.getItem(EXCESS_POPUP_SHOWN_KEY)) {
          setExcessModalVisible(true);
          sessionStorage.setItem(EXCESS_POPUP_SHOWN_KEY, "1");
        }
      }).catch(() => setExcessCount(null)),
    ]);
    setLoading(false);
  }, []);
  useEffect(() => { void refresh(); }, [refresh]);

  const asOf = updated || new Date();
  const month = asOf.getMonth() + 1;
  const rows = data ? dailyRows(data, asOf.getDate()) : [];
  const selected = period === "today" ? rows.slice(-1) : period === "week" ? rows.slice(-7) : rows;
  const totalOrders = rows.reduce((sum, row) => sum + row.orders, 0);
  const totalAmount = rows.reduce((sum, row) => sum + row.amount, 0);
  const today = rows[rows.length - 1];
  const counts = data ? statusCounts(data) : {};
  const statusTotal = Object.values(counts).reduce((sum, count) => sum + count, 0);
  const metricLabel = { amount: "주문금액", orders: "주문건수", buyers: "일별 주문자수" };
  const unit = metric === "amount" ? "원" : metric === "orders" ? "건" : "명";
  const goOrders = (statuses?: string[], title?: string) => {
    if (!statuses?.length) {
      navigate("/admin/order-list");
      return;
    }
    const localDate = (date: Date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };
    const start = new Date(asOf.getFullYear(), asOf.getMonth(), 1);
    const params = new URLSearchParams({
      statuses: statuses.join(","),
      title: title || "확인이 필요한 주문",
      start_date: localDate(start),
      end_date: localDate(asOf),
    });
    navigate(`/admin/order-list?${params.toString()}`);
  };

  return <Layout_Admin menuname="대시보드">
    <Dashboard aria-busy={loading}>
      <AdminPageHeader
        title="운영 대시보드"
        description={`${asOf.getFullYear()}년 ${month}월 주문·배송 현황${updated ? ` · ${updated.toLocaleString("ko-KR")} 업데이트` : ""}`}
        actions={<AdminActionButton type="button" onClick={() => { void refresh(); setOperationsRefresh(value => value + 1); }} disabled={loading}>{loading ? "불러오는 중…" : "새로고침"}</AdminActionButton>}
      />

      <DashboardOperations refreshKey={operationsRefresh} />

      {error && <div className="notice" role="alert">대시보드를 불러오지 못했습니다. {data ? "마지막으로 불러온 정보를 표시하고 있습니다. " : ""}새로고침으로 다시 시도해 주세요.</div>}
      {!data ? <div className="panel empty" role="status">{loading ? "운영 현황을 불러오고 있습니다." : "표시할 데이터를 불러오지 못했습니다."}</div> : <>
        <div className="metrics">
          <div className="card"><span className="label">이번 달 주문금액</span><strong>{number(totalAmount)}<small>원</small></strong><p>오늘 {number(today?.amount || 0)}원</p></div>
          <div className="card"><span className="label">이번 달 주문건수</span><strong>{number(totalOrders)}<small>건</small></strong><p>오늘 {number(today?.orders || 0)}건</p></div>
          <div className="card"><span className="label">주문당 평균 금액</span><strong>{number(totalOrders ? Math.round(totalAmount / totalOrders) : 0)}<small>원</small></strong><p>이번 달 주문금액 ÷ 주문건수</p></div>
          <div className="card"><span className="label">오늘 주문자수</span><strong>{number(today?.buyers || 0)}<small>명</small></strong><p>오늘 주문한 고객 · 중복 제외</p></div>
        </div>
        <div className="columns">
          <section className="panel">
            <div className="section-head" data-admin-tabs-heading=""><div><h2>일별 주문 추이</h2><p>선택 기간: {month}/{selected[0]?.day} ~ {month}/{asOf.getDate()}</p></div><div data-admin-tabs="" className="tabs" aria-label="조회 기간">
              {[["today", "오늘"], ["week", "최근 7일"], ["month", "이번 달"]].map(([key, label]) => <button type="button" key={key} aria-pressed={period === key} onClick={() => setPeriod(key)}>{label}</button>)}
            </div></div>
            <div data-admin-tabs="" className="tabs chart-controls" aria-label="조회 지표">{(["amount", "orders", "buyers"] as const).map(key => <button type="button" key={key} aria-pressed={metric === key} onClick={() => setMetric(key)}>{metricLabel[key]}</button>)}</div>
            <div className="chart"><LineGraph graphData={selected.map(row => row[metric])} labels={selected.map(row => `${month}/${row.day}`)} label={metricLabel[metric]} unit={unit} color="#62539d" /></div>
            {!selected.some(row => row.orders > 0) && <p>선택한 기간에 등록된 주문이 없습니다.</p>}
            <p className="footnote">이번 달 데이터만 표시합니다. 일별 주문자수는 날짜 간 중복될 수 있습니다.</p>
          </section>
          <section className="panel"><h2>확인이 필요한 주문</h2><p>이번 달 주문의 현재 상태 · 주문 상세 건수</p>
            <button type="button" className="task" onClick={() => goOrders(["결제대기"], "결제 확인")}><span>결제 확인<small>결제대기 주문</small></span><strong>{number(counts["결제대기"] || 0)}건</strong></button>
            <button type="button" className="task" onClick={() => goOrders(["결제완료", "발주완료"], "발주 및 배송 준비")}><span>발주 및 배송 준비<small>결제완료 · 발주완료</small></span><strong>{number((counts["결제완료"] || 0) + (counts["발주완료"] || 0))}건</strong></button>
            <button type="button" className="task" onClick={() => goOrders(["사고처리"], "사고처리 내역")}><span>사고처리 내역<small>후속 확인이 필요한 주문</small></span><strong>{number(counts["사고처리"] || 0)}건</strong></button>
            <button type="button" className="task" onClick={() => excessCount ? setExcessModalVisible(true) : goOrders()}><span>초과 주문 알림<small>전체 기간 알림 목록</small></span><strong>{excessCount === null ? "확인 실패" : `${number(excessCount)}건`}</strong></button>
            <p className="footnote">주문 관리에서 방송을 선택한 후 상세 내역을 확인할 수 있습니다.</p>
          </section>
        </div>
        <div className="columns">
          <section className="panel"><div className="section-head"><div><h2>일별 상세 내역</h2><p>그래프와 같은 기간 · 최신 날짜순</p></div><span>{selected.length}일</span></div>
            <div className="table-wrap"><table><thead><tr><th scope="col">날짜</th><th scope="col">주문건수</th><th scope="col">주문자수</th><th scope="col">주문금액</th><th scope="col">주문당 평균</th></tr></thead>
              <tbody>{[...selected].reverse().map(row => <tr key={row.day}><td>{month}/{row.day}{row.day === asOf.getDate() ? " · 오늘" : ""}</td><td>{number(row.orders)}건</td><td>{number(row.buyers)}명</td><td>{number(row.amount)}원</td><td>{number(row.orders ? Math.round(row.amount / row.orders) : 0)}원</td></tr>)}</tbody>
            </table></div>
          </section>
          <section className="panel"><div className="section-head"><div><h2>주문·배송 상태</h2><p>이번 달 주문 상세 총 {number(statusTotal)}건</p></div><button type="button" onClick={() => goOrders()}>주문 관리</button></div>
            <div className="status-grid">{statuses.map(status => <div className="status" key={status}><span>{status}</span><strong>{number(counts[status] || 0)}건</strong></div>)}</div>
          </section>
        </div>
        <p>집계 기준: 주문일 기준 이번 달 주문입니다. 주문금액은 주문에 저장된 금액의 합계이며 실제 결제 완료 매출과 다를 수 있습니다. 주문·배송 상태는 상품별 주문 상세 기준으로 주문건수와 다를 수 있습니다.</p>
      </>}
      <ExcessOrderGlobalModal visible={excessModalVisible} handleModal={() => setExcessModalVisible(false)} liveInfo={excessInfo} excessCount={excessCount || 0} />
    </Dashboard>
  </Layout_Admin>;
};
export default Dashborad;
